// extracted by mini-css-extract-plugin
module.exports = {"accordionComponentWrapper":"kh","header":"ki","accordionWrapper":"kj","accordionHeader":"kk","accordionIcon":"kl","accordionContent":"km"};